<template>
  <!-- 统计 4 卡 -->
  <div class="stats-bar-compact">
    <div
      v-for="card in cards"
      :key="card.key"
      class="stat-mini"
      :class="{
        'stat-mini--clickable': card.clickable,
        'stat-mini--active': card.selected,
        [`stat-mini--active-${card.accent}`]: card.selected && card.accent
      }"
      @click="onCardClick(card)"
    >
      <div class="stat-mini-icon" :class="card.accent">
        <svg
          v-if="card.key === 'total'"
          class="ic"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        ><circle cx="9" cy="8" r="4" /><path
          d="M2 21c0-4 3.1-6.5 7-6.5s7 2.5 7 6.5M16 3.6a4 4 0 0 1 0 7.8M21.5 21c0-3.2-2-5.4-5-6.2"
        /></svg>
        <svg
          v-else-if="card.key === 'compliance'"
          class="ic"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        ><circle cx="12" cy="12" r="9" /><path d="m8.5 12.5 2.5 2.5 5-5.5" /></svg>
        <svg
          v-else-if="card.key === 'soon'"
          class="ic"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        ><path d="M12 3 1.8 20.2h20.4Z" /><path d="M12 9.5v4.5M12 17.2v.3" /></svg>
        <svg
          v-else
          class="ic"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        ><path d="M12 3 1.8 20.2h20.4Z" /><path d="M12 9.5v4.5M12 17.2v.3" /></svg>
      </div>
      <div class="stat-mini-main">
        <div class="stat-mini-value">
          {{ card.value }}
          <span
            v-if="card.trend"
            class="stat-mini-trend"
            :class="card.trend.cls"
          >{{ card.trend.text }}</span>
        </div>
        <div class="stat-mini-label">{{ card.label }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DriverStatCards",
  props: {
    cards: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    onCardClick(card) {
      if (!card || !card.clickable) {
        return;
      }
      this.$emit("card-click", card.key);
    }
  }
};
</script>

<style lang="scss" scoped>
$bg-card: #ffffff;
$border-light: #eff1f5;
$info: #2e5ff0;
$info-bg: #eff4fd;
$success: #0e9f6e;
$success-bg: #e9f8f2;
$warning: #c77414;
$warning-bg: #fcf4e8;
$danger: #d43030;
$danger-bg: #fbf0f0;
$text-1: #111827;
$text-3: #9ca3af;
$radius-lg: 12px;

.stats-bar-compact {
  display: flex;
  background: $bg-card;
  border-radius: $radius-lg;
  border: 1px solid $border-light;
  padding: 14px 0;
  margin-bottom: 16px;
  box-shadow: 0 1px 2px rgba(19, 26, 38, 0.04);
  flex-wrap: wrap;

  .stat-mini {
    flex: 1;
    min-width: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 4px 20px;
    border-right: 1px solid $border-light;
    position: relative;

    &:last-child {
      border-right: none;
    }

    &--clickable {
      cursor: pointer;
      transition: background-color 0.15s ease, box-shadow 0.15s ease;

      &:hover {
        background: rgba(46, 95, 240, 0.04);
      }
    }

    &--active {
      background: rgba(46, 95, 240, 0.06);
      box-shadow: inset 0 0 0 2px rgba(46, 95, 240, 0.35);
      border-radius: 8px;
      margin: 0 4px;
      padding-top: 8px;
      padding-bottom: 8px;
    }

    &--active-orange {
      background: $warning-bg;
      box-shadow: inset 0 0 0 2px rgba(199, 116, 20, 0.45);
    }

    &--active-red {
      background: $danger-bg;
      box-shadow: inset 0 0 0 2px rgba(212, 48, 48, 0.45);
    }
  }

  .stat-mini-icon {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    flex-shrink: 0;

    i {
      font-style: normal;
    }

    &.blue {
      background: $info-bg;
      color: $info;
    }
    &.green {
      background: $success-bg;
      color: $success;
    }
    &.orange {
      background: $warning-bg;
      color: $warning;
    }
    &.red {
      background: $danger-bg;
      color: $danger;
    }
  }

  .stat-mini-main {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  .stat-mini-value {
    font-size: 18px;
    font-weight: 700;
    color: $text-1;
    line-height: 1.2;
    letter-spacing: -0.3px;
    white-space: nowrap;
  }

  .stat-mini-label {
    font-size: 12px;
    color: $text-3;
    font-weight: 500;
    white-space: nowrap;
  }

  .stat-mini-trend {
    font-size: 11px;
    font-weight: 600;
    margin-left: 4px;
    vertical-align: 1px;

    &.up {
      color: $success;
    }
    &.down {
      color: $danger;
    }
    &.warn {
      color: $warning;
    }
  }
}
</style>
